import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import T1 from "../assets/t1.png";
import T2 from "../assets/t2.png";
import T3 from "../assets/t3.png";

const TESTIMONIALS = [
  {
    quote:
      "J'ai écouté la troisième piste un dimanche soir. Le lundi, j'ai envoyé l'offre que je repoussais depuis huit mois. Sans drame, sans préparation. Juste posée.",
    name: "Claire M.",
    role: "Thérapeute psycho-corporelle · Lyon",
    img: T1,
  },
  {
    quote:
      "Ce n'est pas une formation. C'est un déplacement. Quelque chose a lâché à un endroit où aucun coaching n'avait jamais réussi à descendre.",
    name: "Adrien R.",
    role: "Coach business · Bordeaux",
    img: T2,
  },
  {
    quote:
      "La chanson encodée me suit partout. C'est devenu mon ancrage avant chaque prise de parole. Je n'arrive plus à m'excuser d'exister.",
    name: "Inès L.",
    role: "Praticienne énergétique · Paris",
    img: T3,
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      id="temoignages"
      className="relative py-24 md:py-36 px-6 md:px-10 bg-obsidian-surface/40"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 md:mb-20">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            06 · Ce qu'elles & ils en disent
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
            Pas des promesses.{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              des déplacements.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.12,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="relative bg-obsidian border border-white/[0.06] rounded-2xl p-8 md:p-10 hover:border-gold/30 hover:-translate-y-1 transition-all duration-500"
            >
              <Quote className="w-7 h-7 text-gold/70 mb-6" />
              <blockquote className="font-serif text-lg md:text-xl text-ink-50 leading-relaxed mb-10">
                «&nbsp;{t.quote}&nbsp;»
              </blockquote>
              <figcaption className="flex items-center gap-4 pt-6 border-t border-white/5">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover grayscale-[20%]"
                />
                <div>
                  <p className="font-display text-sm uppercase tracking-[0.2em] text-ink-50">
                    {t.name}
                  </p>
                  <p className="font-serif italic text-sm text-ink-400 lowercase">
                    {t.role}
                  </p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
